import { Building2, User, Truck, Settings2 } from "lucide-react";
import Logo from "./Logo";

const PANEL_CFG = {
  landing:    { h: "Property\nManagement,\nRefined.", sub: "A unified platform for residents,\nstaff, and administrators.", I: Building2 },
  resident:   { h: "Welcome\nHome.",                sub: "Stay connected with your\nproperty's valet services.",     I: User },
  valet:      { h: "Ready for\nToday's\nRoute?",    sub: "Your operational dashboard\nawaits.",                      I: Truck },
  hoa:        { h: "Your Property,\nYour Dashboard.",sub: "Real-time community\noperations insight.",               I: Building2 },
  superadmin: { h: "Full System\nControl.",          sub: "Manage all properties\nfrom one central place.",         I: Settings2 },
};

export default function LeftPanel({ role }) {
  const cfg = PANEL_CFG[role] || PANEL_CFG.landing;
  const PIcon = cfg.I;

  return (
    <div className="auth-left" style={{
      background: "linear-gradient(155deg,var(--g900) 0%,var(--g700) 52%,var(--g500) 100%)",
      display: "flex", flexDirection: "column",
      justifyContent: "space-between",
      padding: "44px 44px 44px 48px",
      position: "relative", overflow: "hidden",
    }}>
      {/* Grid texture */}
      <div style={{
        position: "absolute", inset: 0, pointerEvents: "none",
        backgroundImage: `
          linear-gradient(rgba(255,255,255,.022) 1px,transparent 1px),
          linear-gradient(90deg,rgba(255,255,255,.022) 1px,transparent 1px)
        `,
        backgroundSize: "44px 44px",
      }} />

      {/* Orbs */}
      {[
        { w: 300, t: -90, r: -90, d: "0s",   dur: 6 },
        { w: 180, b: 100, l: -55, d: "2.5s", dur: 8 },
        { w: 110, b: 280, r: 30,  d: "5s",   dur: 7 },
      ].map((o, i) => (
        <div key={i} style={{
          position: "absolute", width: o.w, height: o.w, borderRadius: "50%",
          background: "rgba(255,255,255,.04)",
          top: o.t, right: o.r, bottom: o.b, left: o.l,
          animation: `floatY ${o.dur}s ease-in-out ${o.d} infinite`,
          pointerEvents: "none",
        }} />
      ))}

      {/* Logo */}
      <div className="pi"><Logo dark /></div>

      {/* Copy */}
      <div className="pi d2" style={{ zIndex: 1 }}>
        <div style={{
          width: 50, height: 50, borderRadius: 13,
          background: "rgba(255,255,255,.10)",
          border: "1px solid rgba(255,255,255,.15)",
          display: "flex", alignItems: "center", justifyContent: "center",
          marginBottom: 22,
        }}>
          <PIcon size={24} color="rgba(255,255,255,.9)" strokeWidth={1.6} />
        </div>
        <h2 style={{
          fontFamily: "'Playfair Display',serif",
          fontSize: "clamp(26px,2.6vw,36px)", fontWeight: 500,
          color: "#fff", lineHeight: 1.18,
          marginBottom: 16, whiteSpace: "pre-line",
        }}>{cfg.h}</h2>
        <div style={{
          width: 36, height: 3, background: "var(--g400)",
          borderRadius: 2, marginBottom: 16,
          animation: "lineGrow .6s .35s ease both",
        }} />
        <p style={{
          fontSize: "clamp(13px,1.1vw,14.5px)",
          color: "rgba(255,255,255,.56)",
          lineHeight: 1.75, whiteSpace: "pre-line", fontWeight: 300,
        }}>{cfg.sub}</p>
      </div>

      {/* Status dot */}
      <div className="pi d3" style={{ display: "flex", alignItems: "center", gap: 10, zIndex: 1 }}>
        <div style={{
          width: 8, height: 8, borderRadius: "50%",
          background: "var(--g400)",
          boxShadow: "0 0 0 3px rgba(76,175,80,.22)",
          animation: "pulse 2.2s infinite",
        }} />
        <span style={{ fontSize: 11.5, color: "rgba(255,255,255,.4)", letterSpacing: ".5px" }}>
          Secure · Encrypted · Private
        </span>
      </div>
    </div>
  );
}